import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const Drop = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 24 24' {...rest}>
    {type === 'stroke' ? (
      <path
        d='M19.25 14.0561C19.25 18.0295 16.0041 21.2505 12 21.2505C7.99594 21.2505 4.75 18.0295 4.75 14.0561C4.75 9.90142 8.66637 5.38484 10.7422 3.28264C11.4445 2.57148 12.5555 2.57148 13.2578 3.28264C15.3336 5.38484 19.25 9.90142 19.25 14.0561Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    ) : (
      <path
        d='M13.7914 2.75567C12.7955 1.74714 11.2045 1.74713 10.2086 2.75567C9.15198 3.82566 7.61537 5.52113 6.33827 7.49181C5.07184 9.44606 4 11.7626 4 14.0561C4 18.4491 7.58717 22.0005 12 22.0005C16.4128 22.0005 20 18.4491 20 14.0561C20 11.7626 18.9282 9.44606 17.6617 7.49181C16.3846 5.52113 14.848 3.82566 13.7914 2.75567Z'
        fill='currentColor'
      />
    )}
  </IconBase>
);
